
// @ts-check

/**
 *  @typedef {import('./coreTypes').CampaignImageInfo} CampaignImageInfo
 *  @typedef {import('./coreTypes').CampaignObject} CampaignObject
 *  @typedef {import('./coreTypes').CampaignQueryName} CampaignQueryName
 */

import anniversary25th from '../images/campaigns/25th Anniversary.png';
import anniversary25th_browse from '../images/campaigns/browse/25th Anniversary.png';
import artsSchilling from '../images/campaigns/Arts, Schilling, Prayer Chapel bricks.png';
import artsSchilling_browse from '../images/campaigns/browse/Arts, Schilling, Prayer Chapel bricks.png';
import bellList from '../images/campaigns/Bell List.png';
import bellList_browse from '../images/campaigns/browse/Bell List.png';
// import demossFountainPlaque from '../images/campaigns/DeMoss Fountain Plaque.png';
// import demossFountainPlaque_browse from '../images/campaigns/browse/DeMoss Fountain Plaque.png';
//import jflLibrary from '../images/campaigns/JFL Library Brick Campaign.png';
import jflLibrary from '../images/campaigns/browse/JFL Brick Campaign-2.jpg';
import jflLibrary_browse from '../images/campaigns/browse/JFL Library Brick Campaign.png';
import mothersHonor from '../images/campaigns/Mothers Honor Roll.png';
import mothersHonor_browse from '../images/campaigns/browse/Mothers Honor Roll.png';
import namedBuildings from '../images/campaigns/Named Buildings.jpeg';
import namedBuildings_browse from '../images/campaigns/browse/Named Buildings.png';
import theatreSeat from '../images/campaigns/Theatre Seat Naming Project.png';
import theatreSeat_browse from '../images/campaigns/browse/Theatre Seat Naming Project.png';
import townsLecture from '../images/campaigns/Towns Lecture Hall.png';
import townsLecture_browse from '../images/campaigns/browse/Towns Lecture Hall.png';
import supremeCourtroomSeatNaming from '../images/campaigns/Supreme Court Seat.png';
import supremeCourtroomSeatNaming_browse from '../images/campaigns/browse/Supreme Court Seat.png';
import foundersLegacySociety from '../images/campaigns/Founders Legacy Society.png';
import foundersLegacySociety_browse from '../images/campaigns/browse/Founders Legacy Society.png';


/**
 * @param {string} fullUrl 
 * @param {string} browseUrl 
 * @returns {import('./coreTypes').CampaignImageInfo}
 */
function buildImageInfo(fullUrl, browseUrl) {
    return { full: { url: fullUrl}, browse: { url: browseUrl } };
}


const anniversary25thImageInfo = buildImageInfo(anniversary25th, anniversary25th_browse); 
const artsSchillingImageInfo = buildImageInfo(artsSchilling, artsSchilling_browse); 
const bellListImageInfo = buildImageInfo(bellList, bellList_browse); 
//const demossFountainPlaqueImageInfo = buildImageInfo(demossFountainPlaque, demossFountainPlaque_browse);
const jflLibraryImageInfo = buildImageInfo(jflLibrary, jflLibrary_browse); 
const mothersHonorImageInfo = buildImageInfo(mothersHonor, mothersHonor_browse); 
const namedBuildingsImageInfo = buildImageInfo(namedBuildings, namedBuildings_browse); 
const theatreSeatImageInfo = buildImageInfo(theatreSeat, theatreSeat_browse); 
const supremeCourtroomSeatNamingImageInfo = buildImageInfo(supremeCourtroomSeatNaming, supremeCourtroomSeatNaming_browse); 
const townsLectureImageInfo = buildImageInfo(townsLecture, townsLecture_browse); 
const foundersLegacySocietyImageInfo = buildImageInfo(foundersLegacySociety, foundersLegacySociety_browse); 



/**
 * @type {CampaignObject[]}
 */
const CampaignList = [
    { 
        title: '25th Anniversary', 
        info: 'In 1996 Liberty University celebrated the milestone of its 25th Anniversary. The theme was “Twenty-five Years of Miracles.”  It was a campus-wide celebration with banners and commemorations displayed throughout the year. A special 25th anniversary yearbook was created in dedication to the thousands of faithful friends of Liberty who “stood by her, supported her, and believed God for great things.”  Many who gave generously to the University during this 25th year received the popular Liberty Commentary Bible Silver Anniversary Edition, a King James Version parallel Bible commentary edited by Liberty professors Dr. Edward Hindson and Woodrow Kroll.', 
        image: anniversary25thImageInfo, 
        queryName: '25th Anniversary Plaque'
    },
    { 
        title: 'Arts, Schilling, Prayer Chapel Bricks', 
        info: 'One of the early projects in the 1970s launched by Dr. Jerry Falwell to raise funds for the fledgling Liberty Baptist College was the opportunities for donors to "buy" a brick for $500 each. Each brick could be engraved with the name of the donor along with the name of a friend, loved one or someone else who would be honored or memorialized. Thousands of friends gave to this project. For each donation two bricks were actually produced. One was mailed to the donor while the others were eventually placed in several areas around the new campus as it was being constructed.  These included the Fine Arts hall, the Liberty Gym/Schilling Center and the Liberty Chapel.', 
        image: artsSchillingImageInfo, 
        queryName: 'Combined Fine Arts, Schilling,'
    },
    { 
        title: 'Bell List', 
        info: 'In 1976, the American bicentennial year that Lynchburg Baptist College became Liberty Baptist College, a campaign that created a tremendous outpouring of gifts for the young college was "Stake Your Claim on Liberty Mountain."  Dr. Falwell called for thousands of friends of Liberty to enable construction to begin for the first time on the Liberty Mountain campus by making a $100 gift symbolically staking a claim to one square foot of the new campus property. The names of the tens of thousands who gave were placed at the base of the Liberty Bell Shrine which was located near the Vines Center but ultimately was moved to accommodate construction of the new School of Business building.  The Liberty Bell was relocated to the top of the new Freedom Tower, which houses the School of Divinity.', 
        image:  bellListImageInfo, 
        queryName: null
    },
    {
        title: 'Jerry Falwell Library', 
        image: jflLibraryImageInfo, 
        info: 'On January 15, 2014, more than 400 attendees celebrated the grand opening of the new Jerry Falwell Library.  Many special guests were in attendance, including Mrs. Macel Falwell, wife of Liberty University founder, Dr. Jerry Falwell, and the three Falwell children and their families. Dr. Falwell’s twin brother Gene was also in attendance. The library was built on the site where the old Schilling Center gymnasium once stood. Many alumni and other friends of Liberty gave nearly $2.6 million in donations during the two-year Jerry Falwell Library Capital Campaign, making the library possible. The names of these donors appear throughout the facility in various places.  Many donors are recognized within a paver sidewalk at the entrance to the library.',
        queryName: { name: 'Jerry Falwell Library', components: ['Library Donor Wall', 'Jerry Falwell Library Brick', 'Library Naming Opportunity'] } 
    },
    { 
        title: 'Mother\'s Honor Roll',  
        info: 'The Mother’s Honor Roll was a 1983 fundraising project of the Liberty Godparent Home called “Tribute to a Loving Mother.” The first donor to the project was Dr. Jerry Falwell, who paid tribute to his mother Helen B. Falwell. Many other donors contributed to this initiative paying tribute to their mothers also.', 
        image: mothersHonorImageInfo, 
        queryName: 'Mother\'s Honor Roll Plaque'
    },
    { 
        title: 'Named Buildings', 
        info: '', 
        image: namedBuildingsImageInfo, 
        queryName: null
    },
    { 
        title: 'Theatre Seat Naming Project', 
        info: 'The Liberty University Tower Theater is a unique venue for the performing arts. Completed in 2010, the theater features 640 seats with more than 12,000 square feet of backstage and support area, a complex and professional rigging system, and a fly tower which enables Broadway-style productions. Used by the Liberty University Department of Theatre Arts and the Alluvion Stage Company, productions in the Tower Theatre include Brigadoon, Hello, Dolly!, Newsies, South Pacific, Les Miserables and Beauty and the Beast. The Tower Theater also hosts a Summer Arts Program featuring elementary and middle school theater day camps and KIDS Ignite, which teaches students how to communicate the Gospel using a drama ministry. Many donors contributed $1,000 each to name individual seats in the Tower Theater. Additional naming opportunities exist for the main stage, lobby, orchestra pit, balcony, box office and other areas are available.', 
        image: theatreSeatImageInfo, 
        queryName: 'Theater Seat Naming Project'
    },
    { 
        title: 'Towns Lecture Hall', 
        info: 'This spacious lecture hall located within the School of Business facility is named after Liberty University co-founder Dr. Elmer Towns.  Dr. Towns also was served as the primary fundraiser for the original 750 seat Towns/Alumni Auditorium located within the former Religion Hall where the current School of Business now sits.', 
        image: townsLectureImageInfo, 
        queryName: 'Towns Lecture Hall Plaques'
    },
    { 
        title: 'Supreme Courtroom Seat Naming', 
        info: 'A unique aspect of the Liberty University School of Law is the Supreme Courtroom.  This ceremonial, appeals-court level courtroom was designed in replication of the United States Supreme Court in Washington, DC. The bench for nine justices, the angles and measurements, the 17 inch elevation from the floor and the distance of the bench from the podium are exact to that of the High Court. The four large Roman columns behind the bench and the curtains are also patterned after the Supreme Court. This courtroom give Liberty Law students a wonderful opportunity to practice their appellate trial skills during mock court activities, often in tournaments with other law schools. In addition law school chapel, debates, and other activities are held here. Donors are invited to name one of the 330 seats within the Supreme Courtroom and may memorialize or honor a loved one or friend. A plaque outside the entrance lists the name of the donors.', 
        image: supremeCourtroomSeatNamingImageInfo, 
        queryName: 'Supreme Courtroom Seats'
    },
    { 
        title: 'Founders Legacy Society', 
        info: 'The Founders Legacy Society recognizes alumni and friends of Liberty University who make commitments to the future of Liberty University through their estate plans. Provisions for Liberty may take the form of a bequest through a will or trust, a charitable life income plan (charitable gift annuity, charitable remainder trust or charitable lead trust), a gift of property subject to a life estate, or naming Liberty University as the beneficiary of a life insurance policy or retirement plan.', 
        image: foundersLegacySocietyImageInfo, 
        queryName: 'Founders Legacy Society'
    },
];


const campaignSameQueryNames = {
    'Library Bricks': 'Jerry Falwell Library'
};


/**
 * @template T
 * @param {CampaignQueryName} queryName
 * @param {function(string): T} ifString
 * @param {function(): T} ifNull
 * @param {function({name: string, components: string[]}): T} ifComposite
 * @return {T}
 */
const queryNameDispatch = (queryName, ifString, ifNull, ifComposite) => 
{
    if (queryName === null) return ifNull();
    else if (typeof queryName === 'string') return ifString(queryName);
    else if (
        typeof queryName === 'object' 
        && "name" in queryName 
        && "components" in queryName) {
            return ifComposite(queryName);
    }
    else throw new Error('Invalid case for queryName');
};


/**
 * @param {CampaignObject} campaignObject 
 * @returns {string}
 */
const getQueryName = (campaignObject) => {
    return (
        queryNameDispatch(campaignObject.queryName,
            s => s,
            () => campaignObject.title,
            c => c.name));
};

/**
 * @param {CampaignObject} campaignObject 
 * @return {string[]}
 */
const getCompositeQueryNames = (campaignObject) => {
    /** @type {string[]} */
    const strArrayEmpty = [];
    return (
        queryNameDispatch(campaignObject.queryName,
            _ => strArrayEmpty,
            () => strArrayEmpty,
            c => c.components));
};


/**
 * @type {Object.<string, string>}
 */
const campaignNameMap = (function() {
    /**
     * @type {Object.<string, string>}
     */ 
	const map = {};
	for (let i = 0; i < CampaignList.length; i++) {
		const elem = CampaignList[i];
        queryNameDispatch(elem.queryName,
            s => { map[s] = elem.title; },
            () => { },
            c => {
                c.components.forEach(cn => {
                    map[cn] = c.name;
                });
            });
	}

    Object.entries(campaignSameQueryNames).forEach(en => {
        map[en[0]] = en[1];
    });

	return map;
})();

/**
 * @param {string} name 
 * @returns string
 */
const transformCampaignName = (name) => campaignNameMap[name] ?? name;


export default CampaignList;
export { getQueryName, transformCampaignName, getCompositeQueryNames };
